<template>
  <div>
    <Card>
      <Row class="filter-container">
        <el-select clearable
                   style="width: 200px"
                   class="filter-item"
                   v-model="searchData.promote_company_id"
                   :placeholder="$t('pages_customers_index_328')">
          <el-option :label="company.name" :value="company.id" v-for="company in promote_companies" :key="company.id" />
        </el-select>
        <el-button size="medium"
                   class="filter-item"
                   type="primary"
                   icon="el-icon-search"
                   @click="search">{{$t('pages_bills_index_196')}}</el-button>
        <el-button size="medium"
                   class="filter-item"
                   type="primary"
                   @click="add">{{$t('pages_banners_index_178')}}</el-button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="promote_company_staffs"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           :loading="addingPromote"
           @on-ok="handleSubmit"
           :title="formType === 'new' ? $t('pages_promote_index_892') : $t('pages_promote_index_893')">
      <Form ref="promote_company_staff"
            :model="form"
            :rules="formRules"
            :label-width="120">
        <Form-item :label="$t('pages_promote_index_894')"
                    prop="promote_company_id">
            <Select v-model="form.promote_company_id">
              <Option :value="company.id" v-for="company in promote_companies" :key="company.id">{{company.name}}</Option>
            </Select>
        </Form-item>
        <Form-item :label="$t('pages_promote_index_895')"
                   prop="username">
          <Input type="text"
                 v-model="form.username" />
        </Form-item>
        <Form-item :label="$t('pages_promote_index_896')"
                   prop="mobile">
          <Input type="text"
                 v-model="form.mobile" />
        </Form-item>
        <Form-item :label="$t('pages_promote_index_897')"
                   prop="wechat">
          <Input type="text"
                 v-model="form.wechat" />
        </Form-item>
        <Form-item :label="$t('pages_promote_companies_877')"
                   prop="rebate_rate">
          <i-input type="number"
                   v-model="form.rebate_rate">
            <span slot="append">%</span>
          </i-input>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
// import _ from 'lodash'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable, commonButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  watch: {
    promote_company_staff (val) {
      if (val && val.id) {
        this.form = val
      }
    }
  },
  data () {
    return {
      form: {},
      formRules: {
        promote_company_id: [{ required: true, message: i18n.t('pages_promote_index_898') }],
        username: [{ required: true, message: i18n.t('pages_promote_index_899') }],
        mobile: [{ required: true, message: i18n.t('pages_promote_index_900') }],
        rebate_rate: [{ required: true, message: i18n.t('pages_promote_index_901') }],
      },
      searchData: {
        promote_company_id: undefined
      },
      modalShow: false,
      addingPromote: true,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_promote_bill_info_869'),
          key: 'id',
          width: 100
        },
        {
          title: i18n.t('pages_promote_index_894'),
          key: 'promote_company_name',
          align: 'center',
          render (h, params) {
            return <span>{params.row.promote_company.name}</span>
          }
        },
        {
          title: i18n.t('pages_customers_index_329'),
          key: 'username',
          align: 'center'
        },
        {
          title: i18n.t('pages_promote_index_902'),
          key: 'mobile',
          align: 'center'
        },
        {
          title: i18n.t('pages_dashboards_statement_sale_index_415'),
          key: 'wechat',
          align: 'center'
        },
        {
          title: i18n.t('pages_promote_index_903'),
          key: 'rebate_rate',
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at',
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 180,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const children = []
            children.push(
              editorButtonInTable(this, h, params),
              deleteButtonInTable(this, h, params),
              commonButtonInTable(
                this,
                h,
                'success',
                i18n.t('pages_promote_companies_882'),
                this.checkBills,
                [params.row.id]
              )
            )
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.resetQuery()
    this.companyIndex()
  },
  computed: {
    ...mapGetters('promote_company_staff', ['promote_company_staff', 'promote_company_staffs', 'meta', 'loading']),
    ...mapGetters('promote_company', ['promote_companies'])
  },
  methods: {
    ...mapActions('promote_company_staff', [
      'clearRecord',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('promote_company', { companyIndex: 'index' }),
    ...mapMutations('promote_company_staff', ['changeQuery', 'resetQuery']),
    search () {
      const { promote_company_id } = this.searchData
      if (!promote_company_id) {
        return this.$message.warning(i18n.t('pages_promote_index_904'));
      }
      this.resetQuery()
      this.changePage(this.searchData)
    },
    changePage (query) {
      this.changeQuery(query)
      this.index()
    },
    add () {
      this.clearRecord()
      this.form = {}
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      this.$refs.promote_company_staff.validate(async valid => {
        if (!valid) {
          this.addingPromote = false
          this.$nextTick(() => {
            this.addingPromote = true
          })
          return
        }

        if (this.formType === 'edit') {
          await this.update(this.form)
        } else if (this.formType === 'new') {
          await this.create(this.form)
        }
        this.modalShow = false
      })
    },
    checkBills (id) {
      this.$router.push(`/promote/staff/${id}/bills`)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.filter-container {
  padding-bottom: 10px;
  > div {
    margin-right: 8px;
  }
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}
</style>
